import React, { FC } from 'react';
import { priceFormatter } from 'common/helpers/format.helper';
import { IOosOpportunityLossCategoryGroup } from 'entities/MonitorSales/MonitorSales.models';
import { getCategoryColor } from 'entities/MonitorSales/monitorSales.categoryColors';

interface IComponentProps {
  categoryGroup: IOosOpportunityLossCategoryGroup;
  maxPotentialSalesLost: number;
}

export const OosOpportunityLossCategoryGroup: FC<IComponentProps> = ({ categoryGroup, maxPotentialSalesLost }) => {
  return (
    <div className="ms-oos__category">
      <div className="mb-4 ff-medium fs-xxs">{categoryGroup.category}</div>
      {categoryGroup.items.map((item) => (
        <div key={item.productName} className="ms-oos__item">
          <div className="ms-oos__item-header">
            <span className="ms-oos__item-name">{item.productName}</span>
            <span className="ms-oos__item-value">{priceFormatter(item.potentialSalesLost)}</span>
          </div>
          <div className="ms-oos__bar">
            <div
              className="ms-oos__bar-fill"
              style={{
                width: `${(item.potentialSalesLost / maxPotentialSalesLost) * 100}%`,
                background: getCategoryColor(categoryGroup.category),
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
